import styled from "styled-components";

export const CertificationBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
	min-width: 0;
`;

export const CertificationHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 0;
	min-width: 0;
	width: 100%;
`;

export const HeaderMain = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
	min-width: 0;
`;

export const HeaderCopy = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0;
	min-width: 0;
	flex: 1 1 auto;
`;

export const StatusChip = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 30px;
	padding: 0 12px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.01em;
	background-color: ${({ $active }) =>
		$active ? "var(--light-blue-2)" : "var(--light-gray-1)"};
	color: ${({ $active }) =>
		$active ? "var(--light-blue-6)" : "var(--dark-4)"};
`;

export const MutedPanel = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 14px 16px;
	border-radius: 12px;
	border: 1px dashed var(--light-blue-4);
	background-color: var(--light-blue-1);

	& h4,
	& p {
		margin: 0;
	}

	& h4 {
		font-size: 14px;
		font-weight: 600;
		color: var(--dark-3);
	}

	& p {
		font-size: 12px;
		line-height: 1.35;
		color: var(--light-gray-5);
	}
`;

export const ConfigurationShell = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 18px;
	flex-wrap: wrap;
	padding-top: 2px;
	min-width: 0;
`;

export const CompactInfoRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex: 0 1 auto;
	min-width: 0;
`;

export const CompactInfoText = styled.div`
	display: inline-flex;
	align-items: center;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: var(--light-gray-5);
	white-space: nowrap;
`;

export const ContextText = styled.p`
	margin: 0;
	font-size: 12px;
	line-height: 1.35;
	color: var(--dark-4);
	flex: 0 1 auto;
	min-width: 0;
	white-space: nowrap;
	padding-left: 14px;
	border-left: 1px solid var(--light-blue-4);

	& strong {
		color: var(--dark-3);
		font-weight: 600;
	}

	@media (max-width: 640px) {
		padding-left: 0;
		border-left: 0;
	}
`;

export const ToggleGroup = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	flex-wrap: nowrap;
	margin-left: auto;
`;

export const HeaderTopRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 14px;
	flex-wrap: wrap;
	width: 100%;
`;

export const QuantityGroup = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	min-width: 0;
`;

export const QuantityButton = styled.button`
	border: 1px solid
		${({ $active }) =>
			$active ? "var(--light-blue-5)" : "var(--light-blue-4)"};
	background-color: ${({ $active }) =>
		$active ? "var(--light-blue-2)" : "var(--light-1)"};
	color: ${({ $active }) =>
		$active ? "var(--light-blue-6)" : "var(--dark-4)"};
	border-radius: 999px;
	min-width: 34px;
	height: 30px;
	padding: 0 12px;
	font-size: 12px;
	font-weight: 600;
	line-height: 1;
	cursor: pointer;
	transition: 0.2s ease;
	box-shadow: ${({ $active }) =>
		$active ? "0 0 0 1px rgba(111, 156, 255, 0.08)" : "none"};

	&:hover {
		border-color: var(--light-blue-5);
	}
`;

export const AlertStack = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-width: 0;
`;

export const AlertCard = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 8px;
	min-width: 0;
	width: 100%;
	padding: 10px 12px;
	border-radius: 12px;
	border: 1px solid
		${({ $variant }) =>
			$variant === "warning"
				? "rgba(111, 156, 255, 0.2)"
				: "rgba(239, 68, 68, 0.18)"};
	background-color: ${({ $variant }) =>
		$variant === "warning"
			? "rgba(239, 246, 255, 0.9)"
			: "rgba(254, 242, 242, 0.95)"};

	&::before {
		content: "";
		width: 8px;
		height: 8px;
		margin-top: 3px;
		border-radius: 999px;
		background-color: ${({ $variant }) =>
			$variant === "warning" ? "var(--light-blue-5)" : "var(--red-3)"};
		flex-shrink: 0;
	}

	& p {
		margin: 0;
		font-size: 11px;
		line-height: 1.3;
		color: ${({ $variant }) =>
			$variant === "warning" ? "var(--light-blue-6)" : "var(--red-3)"};
	}
`;

export const SignatureGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 14px;
	width: 100%;
	min-width: 0;
	justify-content: flex-start;

	& > * {
		min-width: 0;
	}

	${({ $count }) =>
		$count === 1
			? `
				& > * {
					flex: 0 1 420px;
					max-width: 420px;
				}
			`
			: $count === 2
				? `
					& > * {
						flex: 1 1 calc((100% - 14px) / 2);
						max-width: calc((100% - 14px) / 2);
					}
				`
				: `
					& > * {
						flex: 1 1 calc((100% - 28px) / 3);
						max-width: calc((100% - 28px) / 3);
					}
				`}

	@media (max-width: 1120px) {
		& > * {
			flex: 1 1 calc((100% - 14px) / 2);
			max-width: calc((100% - 14px) / 2);
		}
	}

	@media (max-width: 640px) {
		& > * {
			flex: 1 1 100%;
			max-width: 100%;
		}
	}
`;

export const SignatureSlotCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 12px;
	border: 1px solid
		${({ $statusVariant }) =>
			$statusVariant === "success"
				? "rgba(73, 199, 122, 0.35)"
				: $statusVariant === "error"
					? "rgba(255, 92, 92, 0.2)"
					: "var(--light-blue-4)"};
	border-radius: 12px;
	background-color: var(--light-1);
	box-shadow: ${({ $statusVariant }) =>
		$statusVariant === "success"
			? "0 0 0 1px rgba(73, 199, 122, 0.05)"
			: $statusVariant === "error"
				? "0 0 0 1px rgba(255, 92, 92, 0.03)"
				: "none"};
	min-width: 0;
	width: 100%;
	height: fit-content;
	align-self: start;
	overflow: hidden;
`;

export const PositionBadge = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 3px;
	border-radius: 999px;
	border: 1px solid var(--light-blue-4);
	background-color: var(--light-1);
`;

export const PositionBadgeItem = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 32px;
	height: 22px;
	padding: 0 6px;
	border-radius: 999px;
	font-size: 9px;
	font-weight: 700;
	letter-spacing: 0.03em;
	background-color: ${({ $active }) =>
		$active ? "var(--light-blue-2)" : "transparent"};
	color: ${({ $active }) =>
		$active ? "var(--light-blue-6)" : "var(--light-gray-4)"};
	transition: 0.2s ease;
`;

export const SlotHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 10px;
	flex-wrap: wrap;
`;

export const SlotSummary = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0;

	& h4,
	& p {
		margin: 0;
	}

	& h4 {
		font-size: 13px;
		font-weight: 600;
		color: var(--dark-3);
	}

	& p {
		display: none;
	}
`;

export const SlotStatus = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 4px 8px;
	border-radius: 999px;
	background-color: ${({ $variant }) =>
		$variant === "success"
			? "rgba(73, 199, 122, 0.12)"
			: $variant === "error"
				? "rgba(255, 92, 92, 0.08)"
				: "var(--light-blue-1)"};

	& span {
		font-size: 11px;
		font-weight: 700;
		color: ${({ $variant }) =>
			$variant === "success"
				? "var(--green-3)"
				: $variant === "error"
					? "var(--red-3)"
					: "var(--light-gray-5)"};
	}

	& svg {
		width: 14px;
		height: 14px;
		flex-shrink: 0;
	}
`;

export const SlotMeta = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	min-width: 0;
`;

export const ResultBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	width: 100%;
	min-width: 0;
	padding: 10px 12px;
	border-radius: 10px;
	background-color: var(--light-blue-1);
`;

export const ResultValue = styled.strong`
	margin: 0;
	font-size: 13px;
	font-weight: 600;
	line-height: 1.3;
	color: var(--dark-3);
	word-break: break-word;
`;

export const ResultMeta = styled.span`
	margin: 0;
	font-size: 11px;
	line-height: 1.3;
	color: var(--light-gray-5);
`;

export const StatusDot = styled.span`
	width: 8px;
	height: 8px;
	border-radius: 999px;
	background-color: var(--light-gray-4);
	flex-shrink: 0;
`;

export const InlineNote = styled.p`
	margin: 0;
	font-size: 11px;
	line-height: 1.35;
	color: var(--light-gray-5);
`;
